<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">404</h1>
          <h4 class="pt-3">Xin lỗi! Có vấn đề.</h4>
          <p class="text-muted">Trang bạn tìm kiếm không tồn tại.</p>
        </div>
        <CButton color="primary" class="px-4" size="large" to="/">Quay lại trang chủ</CButton>
      </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
